import { DataTypes, DateTypes, SaleType } from "src/utils/configs";
import Highcharts from "highcharts";
import {
  AptFromOptions,
  AptHouseholdFromOptions,
  AptHouseholdToOptions,
  AptRankFromOptions,
  AptRankToOptions,
  AptToOptions,
} from "./toggle-options";
import {
  AptYearFromToOptions,
  AptHouseholdFromToOptions,
  AptPyeongFromToOptions,
  AptDealPriceFromToOptions,
  AptDealPricePerSpaceFromToOptions,
  AptLeasePriceRatioFromToOptions,
  AptGapFromToOptions,
} from "./toggle-options2";
import {
  regionColors,
  chartColors,
  dealType,
  heatmap,
} from "./design";

const sidoGeoOffset = new Map([
  ["서울시", { x: 0, y: 0 }],
  ["경기도", { x: 10, y: 20 }],
  ["인천시", { x: 20, y: 0 }],
  ["세종시", { x: 0, y: 0 }],
  ["대전시", { x: 0, y: 0 }],
  ["부산시", { x: 0, y: 0 }],
  ["대구시", { x: 0, y: 0 }],
  ["울산시", { x: 0, y: 0 }],
  ["전남광주시", { x: 0, y: 0 }],
  ["강원도", { x: 0, y: 0 }],
  ["충청북도", { x: 0, y: -20 }],
  ["충청남도", { x: -20, y: 0 }],
  ["경상북도", { x: -30, y: 0 }],
  ["경상남도", { x: 0, y: 0 }],
  ["전라북도", { x: 0, y: 0 }],
  ["제주도", { x: 0, y: 0 }],
]);

export const highLevels = [
  "전국",
  "강남11개구",
  "강북14개구",
  "수도권",
  "6개광역시",
  "5개광역시",
  "기타지방",
];

const highLevel = new Set(highLevels);

export const isHighLevel = (name) => {
  return highLevel.has(name);
};

const pointRanges = new Map([
  [DateTypes.MONTHLY, 24 * 3600 * 1000 * 25],
  [DateTypes.YEARLY, 24 * 3600 * 1000 * 200],
  [DateTypes.WEEKLY, 24 * 3600 * 1000 * 5],
  [DateTypes.DAILY, 24 * 3600 * 1000 * 1],
]);

// const hexToRgba = (hex, alpha) => {
//   // # 기호를 제거하고, hex 코드가 3자리일 경우 6자리로 변환
//   const validHex = hex.replace("#", "");
//   const r = parseInt(validHex.substring(0, 2), 16); // Red
//   const g = parseInt(validHex.substring(2, 4), 16); // Green
//   const b = parseInt(validHex.substring(4, 6), 16); // Blue

//   // rgba 문자열로 결과 반환
//   return `rgba(${r}, ${g}, ${b}, ${alpha})`;
// };

export const getSystemColor = (index = 0, alpha = 1, brighten = 0) => {
  const safeIndex = Number.isFinite(index) ? index : 0;
  const remain = safeIndex % chartColors.length;
  const hex = chartColors[remain];
  return modifyColor(hex, alpha, brighten);
};

export const getRegionColorWithIndex = (index, alpha = 1, brighten = 0) => {
  const colors = Array.from(regionColors.values()); // ✅ Iterator → Array
  const remain = index % colors.length;
  const hex = colors[remain];
  return modifyColor(hex, alpha, brighten);
};

export const modifyColor = (color, alpha = 1, brighten = 0) => {
  const changed = new Highcharts.Color(color)
    .brighten(brighten)
    .setOpacity(alpha)
    .get();
  return changed;
};

// yellow 를 #ffff00 으로 변경
export const cssColorNameToHex = (colorName) => {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.fillStyle = colorName;
  return ctx.fillStyle; // 결과: "#ffff00"
};

export const isObject = (value) => {
  return value !== null && typeof value === "object";
};

export const isNullOrEmpty = (str) => {
  return !str;
};

export const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};

export const getSidoGeoOffset = (sidoName) => {
  return sidoGeoOffset.get(sidoName);
};

export const getSidoColor = (sidoName, alpha = 1) => {
  const hexColor = regionColors.get(sidoName);
  if (!hexColor) {
    return null; // Return null if the color is not found
  }

  if (alpha === 1) {
    return hexColor; // Return the original color if alpha is 1
  }

  // Convert hex to RGBA
  const hexToRgba = (hex, alpha) => {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return hexToRgba(hexColor, alpha);
};

export const getSidoLightColor = (sidoName, brighten = -0.2) => {
  var color = getSidoColor(sidoName);
  return getBrightenColor(color, brighten);
};

export const getBrightenColor = (color, brighten) => {
  return new Highcharts.Color(color).brighten(brighten).get();
};

export const getTypeColor = (type, alpha = 1) => {
  if (type === DataTypes.DEAL) {
    return dealType.deal.replace(/[\d.]+\)$/, `${alpha})`);
  } else if (type === DataTypes.LEASE) {
    return dealType.lease.replace(/[\d.]+\)$/, `${alpha})`);
  } else if (type === DataTypes.RENT) {
    return dealType.rent.replace(/[\d.]+\)$/, `${alpha})`);
  } else if (type === DataTypes.NORMAL) {
  } else if (type === DataTypes.NORMAL) {
    return getSystemColor(2);
  } else if (type === DataTypes.BUYER_MANY) {
    return getSystemColor(0);
  } else if (type === DataTypes.SELLER_MANY) {
    return getSystemColor(2);
  } else if (type === DataTypes.ENOUGH) {
    return getSystemColor(0);
  } else if (type === DataTypes.LEAK) {
    return getSystemColor(2);
  } else if (type === DataTypes.DEAL_ACTIVITY) {
    return getSystemColor(0);
  } else if (type === DataTypes.DEAL_QUIET) {
    return getSystemColor(2);
  } else if (type === DataTypes.LEASE_ACTIVITY) {
    return getSystemColor(0);
  } else if (type === DataTypes.LEASE_QUIET) {
    return getSystemColor(2);
  } else if (type === DataTypes.DEAL_INCREASE) {
    return getSystemColor(0);
  } else if (type === DataTypes.DEAL_DECREASE) {
    return getSystemColor(2);
  } else if (type === DataTypes.LEASE_INCREASE) {
    return getSystemColor(0);
  } else if (type === DataTypes.LEASE_DECREASE) {
    return getSystemColor(2);
  } else if (type === DataTypes.PERMIT) {
    return getSystemColor(0);
  } else if (type === DataTypes.START) {
    return getSystemColor(1);
  } else if (type === DataTypes.END) {
    return getSystemColor(2);
  } else if (type === DataTypes.SALE) {
    return getSystemColor(3);
  }

  return dealType.deal.replace(/[\d.]+\)$/, `${alpha})`);
};

export const getPointRange = (dateType) => {
  return pointRanges.get(dateType);
};

export const deepEquals = (obj1, obj2) => {
  if (obj1 === null || obj2 === null) {
    return obj1 === obj2;
  }

  // 타입이 다르면 동등하지 않음
  if (typeof obj1 !== typeof obj2) {
    return false;
  }

  // 객체 또는 배열이 아니면 값 자체를 비교
  if (typeof obj1 !== "object" || obj1 === null) {
    return obj1 === obj2;
  }

  // 배열의 길이가 다르면 동등하지 않음
  if (Array.isArray(obj1) && obj1.length !== obj2.length) {
    return false;
  }

  // 객체의 모든 속성 또는 배열의 모든 요소에 대해 재귀적으로 비교
  for (let key in obj1) {
    if (!obj2.hasOwnProperty(key) || !deepEquals(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};

export function deepCopy(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  if (obj instanceof Array) {
    return obj.reduce((arr, item, index) => {
      arr[index] = deepCopy(item);
      return arr;
    }, []);
  }

  if (obj instanceof Object) {
    return Object.keys(obj).reduce((newObj, key) => {
      newObj[key] = deepCopy(obj[key]);
      return newObj;
    }, {});
  }
}

export const isObjectInList = (obj, list) => {
  return list.some((item) => deepEquals(obj, item));
};

export const findIndexByDeepEqual = (obj, list) => {
  for (let i = 0; i < list.length; i++) {
    if (deepEquals(obj, list[i])) {
      return i;
    }
  }
  return -1; // 해당 객체가 배열에 없는 경우
};

export const areSameType = (param1, param2) => {
  // 이 함수는 타입 비교인데, array, object의 경우 둘다 type of가 object가 뜨기 때문에 확인 필요
  const isObject = (value) =>
    typeof value === "object" && !Array.isArray(value);

  return (
    (isObject(param1) && isObject(param2) && typeof param1 === typeof param2) ||
    (Array.isArray(param1) && Array.isArray(param2)) ||
    (typeof param1 === typeof param2 &&
      !isObject(param1) &&
      !Array.isArray(param1))
  );
};

export const hasMoreThanHalfNull = (arr) => {
  if (!Array.isArray(arr)) {
    throw new Error("Input is not an array");
  }

  const nullCount = arr.filter((item) => item === null).length;
  return nullCount > arr.length / 2;
};

export const formatNumber = (value, fixed = 2, multiple = 1) => {
  return formatYAxisLabel(value, fixed, multiple);
};

export const formatYAxisLabel = (value, fixed = 2, multiple = 1) => {
  if (value == null || isNaN(value)) return "";

  const v = value * multiple;
  const abs = Math.abs(v);
  const sign = v < 0 ? "-" : "";

  if (abs >= 100000000) {
    return sign + (abs / 100000000).toFixed(fixed) + "억";
  } else if (abs >= 10000) {
    // 100만(100만) 이상은 소수점 없이, 10만 이하는 fixed 적용
    const manFixed = abs >= 1000000 ? 0 : fixed;
    return sign + (abs / 10000).toFixed(manFixed) + "만";
  }

  // 소수 불필요하면 fixed 제거해도 됨
  return sign + abs.toFixed(fixed);
};

export const roundToTwoDecimal = (value) => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

export const sortBySecondItemIn = (a, b) => {
  // 첫 번째 아이템은 a[0], b[0]로 접근 가능하고,
  // 두 번째 아이템은 a[1], b[1]로 접근 가능합니다.
  return a[1] - b[1]; // 숫자 기준으로 오름차순 정렬
};

export const sortBySecondItemDe = (a, b) => {
  // 첫 번째 아이템은 a[0], b[0]로 접근 가능하고,
  // 두 번째 아이템은 a[1], b[1]로 접근 가능합니다.
  return b[1] - a[1]; // 숫자 기준으로 오름차순 정렬
};

export const zip = (...arrays) => {
  const length = Math.min(...arrays.map((arr) => arr.length));
  return Array.from({ length }, (_, i) => arrays.map((array) => array[i]));
};

export const getGradientColor = (value, min, max, stops, opacity = 1) => {
  if (value <= min) {
    return toRgba(stops[0][1], opacity);
  } else if (value >= max) {
    return toRgba(stops[stops.length - 1][1], opacity);
  }

  const ratio = (value - min) / (max - min);
  for (let i = 1; i < stops.length; i++) {
    if (ratio < stops[i][0]) {
      const [r1, c1] = stops[i - 1];
      const [r2, c2] = stops[i];
      const t = (ratio - r1) / (r2 - r1);
      return interpolateColor(c1, c2, t, opacity);
    }
  }
  return toRgba(stops[stops.length - 1][1], opacity);
};

/**
 * 0을 흰색 기준으로 두고 양수는 빨강, 음수는 파랑으로 발산하는 그라데이션 색상.
 * 양/음 각각 maxPositive, maxNegative를 진한색의 한계로 사용 (비대칭 정규화).
 * @param {number} value 평가할 값
 * @param {number} maxPositive 양수 측 최대값 (>0). 0 이하면 양수 입력은 흰색.
 * @param {number} maxNegative 음수 측 최소값 (<0). 0 이상이면 음수 입력은 흰색.
 * @returns {{color: string, ratio: number}} rgba 색상과 짙기 비율(0~1).
 */
export const getDivergentColor = (value, maxPositive, maxNegative) => {
  const neutral = toRgba(heatmap.neutral);
  if (!value) return { color: neutral, ratio: 0 };
  if (value > 0) {
    if (!maxPositive || maxPositive <= 0) return { color: neutral, ratio: 0 };
    const ratio = Math.min(1, value / maxPositive);
    return { color: interpolateColor(heatmap.neutral, heatmap.increase, ratio), ratio };
  }
  if (!maxNegative || maxNegative >= 0) return { color: neutral, ratio: 0 };
  const ratio = Math.min(1, value / maxNegative); // 둘 다 음수 → 양의 비율
  return { color: interpolateColor(heatmap.neutral, heatmap.decrease, ratio), ratio };
};

/**
 * 증감 색상용 양/음 경계를 극단값 대신 분위수로 잡는다.
 * outlier가 하나만 커도 나머지 마커가 흰색으로 눌리지 않도록 색상용 max/min만 낮춘다.
 */
export const getRobustDivergentBounds = (values, percentile = 0.9) => {
  const positives = [];
  const negatives = [];

  for (const value of values ?? []) {
    if (typeof value !== "number" || !Number.isFinite(value) || value === 0) continue;
    if (value > 0) positives.push(value);
    if (value < 0) negatives.push(value);
  }

  positives.sort((a, b) => a - b);
  negatives.sort((a, b) => a - b);

  const positiveIndex = Math.floor((positives.length - 1) * percentile);
  // 하위 10% 경계는 양수의 상위 90%와 대칭이 되도록 올림 인덱스를 사용한다.
  // 0.9의 부동소수점 표현 때문에 0.999...가 되어 극단 최솟값을 택하는 것을 막는다.
  const negativeIndex = Math.ceil((negatives.length - 1) * (1 - percentile));

  return {
    maxPos: positives.length > 0 ? positives[Math.max(0, positiveIndex)] : 0,
    maxNeg: negatives.length > 0 ? negatives[Math.max(0, negativeIndex)] : 0,
  };
};

/**
 * 마커 스택에서 가장 위에 표시되는 유효 데이터층의 z-index를 반환한다.
 * 순위가 없는 이름/설명층만 있으면 네이버 지도 기본 순서인 0을 사용한다.
 */
export const getTopMarkerZIndex = (components) => {
  const topDataComponent = (components ?? [])
    .find((component) => Number.isFinite(component?.zIndex));
  return topDataComponent?.zIndex ?? 0;
};

/** 표시 순위가 높을수록 지도 마커가 위에 오도록 고정한다. */
export const getRankMarkerZIndex = (ranking) =>
  Number.isFinite(ranking) ? 10000 - ranking : 0;

/** Rank displayed changes by signed value, preserving ties and ignoring missing values. */
export const getChangeMarkerZIndexes = (markers, changeMap, metricKey) => {
  const rows = (markers ?? []).flatMap((marker) => {
    const change = changeMap?.[marker.id]?.[metricKey];
    if (change?.change == null) return [];
    const value = change.change * (change.magnification ?? 1);
    return Number.isFinite(value) ? [{ id: marker.id, value }] : [];
  }).sort((left, right) => right.value - left.value);
  const result = new Map();
  let previousValue;
  let rank = 0;
  rows.forEach((row, index) => {
    if (index === 0 || row.value !== previousValue) rank = index + 1;
    previousValue = row.value;
    result.set(row.id, getRankMarkerZIndex(rank));
  });
  return result;
};

/**
 * 일반 gradient 색상용 min/max를 분위수로 잡는다.
 * 실제 값과 필터 범위는 유지하고, 색상 경계만 outlier에 덜 민감하게 만든다.
 */
export const getRobustRangeBounds = (values, lowerPercentile = 0.1, upperPercentile = 0.9) => {
  const sorted = (values ?? [])
    .filter((value) => typeof value === "number" && Number.isFinite(value))
    .sort((a, b) => a - b);

  if (sorted.length === 0) return { min: 0, max: 0 };
  if (sorted.length === 1) return { min: sorted[0], max: sorted[0] };

  const minIndex = Math.floor((sorted.length - 1) * lowerPercentile);
  const maxIndex = Math.ceil((sorted.length - 1) * upperPercentile);

  return {
    min: sorted[Math.max(0, minIndex)],
    max: sorted[Math.min(sorted.length - 1, maxIndex)],
  };
};

export const interpolateColor = (color1, color2, t, opacity = 1) => {
  const [r1, g1, b1] = color1.match(/\w\w/g).map((c) => parseInt(c, 16));
  const [r2, g2, b2] = color2.match(/\w\w/g).map((c) => parseInt(c, 16));

  const r = Math.round(r1 + (r2 - r1) * t);
  const g = Math.round(g1 + (g2 - g1) * t);
  const b = Math.round(b1 + (b2 - b1) * t);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const toRgba = (hex, opacity = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((c) => parseInt(c, 16));
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const sortByProperty = (
  array,
  property,
  desc = true,
  from = 0,
  to = null,
) => {
  const getValue = (obj, path) =>
    path.split(".").reduce((acc, part) => acc && acc[part], obj);

  const sorted = [...array].sort((a, b) => {
    let valueA = getValue(a, property);
    let valueB = getValue(b, property);

    // null, undefined, NaN을 최소값으로 처리
    if (valueA === null || valueA === undefined || Number.isNaN(valueA)) {
      valueA = -Infinity;
    }
    if (valueB === null || valueB === undefined || Number.isNaN(valueB)) {
      valueB = -Infinity;
    }

    if (valueA > valueB) return desc ? -1 : 1;
    if (valueA < valueB) return desc ? 1 : -1;
    return 0;
  });

  // from-to 범위 처리
  if (
    typeof from === "number" &&
    from >= 0 &&
    typeof to === "number" &&
    to > 0
  ) {
    return sorted.slice(from, to);
  }

  return sorted;
};

export const getAverage = (
  data,
  percent = 100,
  useAbs = false,
  includeNull = false,
) => {
  if (!Array.isArray(data) || data.length === 0) {
    return 0;
  }

  let processedData = useAbs
    ? data.map((v) => (v === null ? null : Math.abs(v)))
    : [...data];

  if (!includeNull) {
    // null, undefined, NaN 제거
    processedData = processedData.filter(
      (v) => v !== null && v !== undefined && !Number.isNaN(v),
    );
    if (processedData.length === 0) {
      return 0;
    }
  } else {
    // null은 0으로 처리
    processedData = processedData.map((v) =>
      v === null || v === undefined || Number.isNaN(v) ? 0 : v,
    );
  }

  const sum = processedData.reduce((acc, num) => acc + num, 0);
  const average = sum / processedData.length;

  return average * (percent / 100);
};

export const roundTo = (num, roundCount = 2) => {
  return num !== null ? parseFloat(num.toFixed(roundCount)) : null;
};

export const debounce = (func, delay) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), delay);
  };
};

export const isHtmlContentEmpty = (htmlContent) => {
  // DOMParser를 사용하여 HTML 파싱
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const textContent = doc.body.textContent || ""; // body의 텍스트 콘텐츠 추출
  return textContent.trim() === ""; // 텍스트만 평가
};

export const matchBungi = (aptBungi, minBungi) => {
  if (!aptBungi || !minBungi) return false;

  // "번지일원", "번지 일원", "번지" 제거 (공백 포함 유무에 관계없이)
  const cleanedBungi = aptBungi.replace(/\s*번지(\s*일원)?\s*/g, "").trim();

  return cleanedBungi === minBungi;
};

export const getRandomId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 6);
};

export const getFilterDesc = (f, { subtitle = false, pyeongLabel } = {}) => {
  if (!f) return "";

  const parts = [];

  // --------------------------
  // 1) 연식 (from / to)
  // --------------------------
  // Enabling filters does not necessarily set an age range.
  const from = f.from ?? AptFromOptions.default;
  const to = f.to ?? AptToOptions.default;

  const fromDefault = AptFromOptions.default; // 200
  const toDefault = AptToOptions.default; // 0
  const toAll = -10;

  const noFrom = from === fromDefault;
  const noTo = to === toDefault || to === toAll;

  let yearText = "";

  if (!noFrom && !noTo && to !== 0 && to !== -10) {
    yearText = `${from}~${to}년`;
  } else if (!noFrom && noTo) {
    yearText = `${from}년 이하`;
  } else if (noFrom && !noTo && to !== 0 && to !== -10) {
    yearText = `${to}년 이상`;
  }

  if (yearText) parts.push(subtitle ? `연식 ${yearText}` : yearText);

  // --------------------------
  // 2) 세대수 (fromh / toh)
  // --------------------------
  const fromh = f.fromh ?? 0;
  const toh = f.toh ?? AptHouseholdToOptions.default;

  const hsFromDefault = AptHouseholdFromOptions.default;
  const hsToDefault = AptHouseholdToOptions.default; // 100000

  let hsText = "";

  if (!((fromh === 0 || fromh === hsFromDefault) && toh === hsToDefault)) {
    if (fromh != null && toh != null) {
      if (toh === hsToDefault) {
        hsText = `${fromh}세대 이상`;
      } else if (fromh === 0) {
        hsText = `${toh}세대 이하`;
      } else {
        hsText = `${fromh}~${toh}세대`;
      }
    }
  }

  if (hsText) parts.push(hsText);

  // --------------------------
  // 3) 평형 (fromp)
  // --------------------------
  const fromp = f.fromp ?? 0;
  const top = f.top ?? 10000;
  if (fromp !== 0 || top !== 10000) {
    const pyeongText = top === 10000
      ? `${fromp}평 이상`
      : fromp === 0
        ? `${top}평 이하`
        : `${fromp}~${top}평`;
    parts.push(pyeongLabel ?? pyeongText);
  }

  // --------------------------
  // 4) 순위 필터 (fromr / tor)
  // --------------------------
  const fromr = f.fromr ?? AptRankFromOptions.default;
  const tor = f.tor ?? AptRankToOptions.default;

  const rankFromDefault = AptRankFromOptions.default; // 0
  const rankToDefault = AptRankToOptions.default; // 100000

  let rankText = "";

  // 둘 다 기본값이면 필터 없음
  if (!(fromr === rankFromDefault && tor === rankToDefault)) {
    if (fromr > rankFromDefault && tor === rankToDefault) {
      // 10위~ → 10위 이상
      rankText = `${fromr}위 이상`;
    } else if (fromr === rankFromDefault && tor < rankToDefault) {
      // ~10위 → 10위 이하
      rankText = `${tor}위 이하`;
    } else if (fromr > rankFromDefault && tor < rankToDefault) {
      // 20~10위 → 20~10위
      rankText = `${fromr}~${tor}위`;
    }
  }

  if (rankText) parts.push(subtitle ? `평당가 순위 ${rankText}` : rankText);

  // --------------------------
  // 최종 출력
  // --------------------------
  if (parts.length === 0) return "";

  return subtitle ? parts.join(" · ") : `(${parts.join(",")})`;
};

export const generateRange = (
  min,
  max,
  count,
  {
    integer = false, // true면 int, false면 double
    precision = 2, // double일 때 소수 자리수
  } = {},
) => {
  if (count <= 0) return [];
  if (count === 1) {
    const v = min;
    return [integer ? Math.round(v) : Number(v.toFixed(precision))];
  }

  const step = (max - min) / (count - 1);

  return Array.from({ length: count }, (_, i) => {
    const v = min + step * i;
    return integer ? Math.round(v) : Number(v.toFixed(precision));
  });
};

export const findClosestIndex = (arr, value) => {
  if (!Array.isArray(arr) || arr.length === 0 || typeof value !== "number") {
    return -1;
  }

  let closestIndex = 0;
  let minDiff = Math.abs(arr[0] - value);

  for (let i = 1; i < arr.length; i++) {
    const v = arr[i];
    if (typeof v !== "number") continue;

    const diff = Math.abs(v - value);
    if (diff < minDiff) {
      minDiff = diff;
      closestIndex = i;
    }
  }

  return closestIndex;
};

export const findClosestIndexSorted = (arr, value) => {
  if (!Array.isArray(arr) || arr.length === 0 || typeof value !== "number") {
    return -1;
  }

  if (value <= arr[0]) return 0;
  if (value >= arr[arr.length - 1]) return arr.length - 1;

  let left = 0;
  let right = arr.length - 1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const midVal = arr[mid];

    if (midVal === value) return mid;
    if (midVal < value) left = mid + 1;
    else right = mid - 1;
  }

  // left: value보다 큰 첫 index
  // right: value보다 작은 마지막 index
  return Math.abs(arr[left] - value) < Math.abs(arr[right] - value)
    ? left
    : right;
};

// 부동소수 비교/이벤트 스팸 방지용 (필요하면 조정)
export const nearlyEqual = (a, b, eps = 1e-10) => Math.abs(a - b) < eps;

/**
 * 옵션 배열에서 value에 해당하는 label을 찾아 반환
 */
const getLabel = (options, value) => {
  const found = options.find((opt) => opt.value === value);
  return found?.label ?? String(value);
};

/**
 * 범위 라벨 계산 (CustomPopover subText용)
 * @param {number} from - from 값
 * @param {number} to - to 값
 * @param {Object} opts - options 객체 (defaultFrom, defaultTo, options 포함)
 * @param {boolean} reverse - reverse 모드 여부 (년식: true, 나머지: false)
 * @returns {string} - 범위 라벨 (예: "전체", "30년 이상", "100세대~200세대")
 */
export const computeRangeLabel = (from, to, opts, reverse = false) => {
  const options = opts.options;
  const firstValue = options[0].value; // 가장 큰 값 (전체)
  const lastValue = options[options.length - 1].value; // 가장 작은 값

  const fromLabel = options.find((opt) => opt.value === from)?.label ?? "";
  const toLabel = options.find((opt) => opt.value === to)?.label ?? "";

  const isFromAtStart = reverse ? from === firstValue : from === lastValue;
  const isToAtEnd = reverse ? to === lastValue : to === firstValue;

  if (isFromAtStart && isToAtEnd) {
    return "전체";
  } else if (isFromAtStart && !isToAtEnd) {
    return `${toLabel} ${reverse ? "이상" : "이하"}`;
  } else if (!isFromAtStart && isToAtEnd) {
    return `${fromLabel} ${reverse ? "이하" : "이상"}`;
  } else {
    return `${fromLabel}~${toLabel}`;
  }
};

/**
 * 필터 상태를 기반으로 기본 필터 이름 생성
 * @param {Object} filter - 필터 객체
 * @returns {string} - 생성된 필터 이름
 */
export const getAptFilterName = (filter) => {
  if (!filter) return "";

  const parts = [];

  // 헬퍼: from/to 필터 텍스트 생성 (통합 옵션 사용)
  const buildRangeText = (from, to, opts, label) => {
    const fromDefault = opts.defaultFrom;
    const toDefault = opts.defaultTo;

    const isFromDefault = from === fromDefault;
    const isToDefault = to === toDefault;

    if (isFromDefault && isToDefault) return null;

    const fromLabel = getLabel(opts.options, from);
    const toLabel = getLabel(opts.options, to);

    // defaultFrom > defaultTo인 경우 (예: 년식) 이상/이하 반대
    const isReversed = fromDefault > toDefault;

    if (!isFromDefault && !isToDefault) {
      return `${label} ${fromLabel}~${toLabel}`;
    } else if (isFromDefault && !isToDefault) {
      // from이 기본값, to만 변경됨
      return `${label} ${toLabel} ${isReversed ? "이상" : "이하"}`;
    } else if (!isFromDefault && isToDefault) {
      // to가 기본값, from만 변경됨
      return `${label} ${fromLabel} ${isReversed ? "이하" : "이상"}`;
    }

    return null;
  };

  // 1) 년식
  const yearText = buildRangeText(
    filter.from,
    filter.to,
    AptYearFromToOptions,
    "년식",
  );
  if (yearText) parts.push(yearText);

  // 2) 세대수
  const householdText = buildRangeText(
    filter.fromh,
    filter.toh,
    AptHouseholdFromToOptions,
    "세대수",
  );
  if (householdText) parts.push(householdText);

  // 3) 평형
  const pyeongText = buildRangeText(
    filter.fromp,
    filter.top,
    AptPyeongFromToOptions,
    "평형",
  );
  if (pyeongText) parts.push(pyeongText);

  // 4) 시세 (거래가)
  const dealPriceText = buildRangeText(
    filter.fromDp,
    filter.toDp,
    AptDealPriceFromToOptions,
    "시세",
  );
  if (dealPriceText) parts.push(dealPriceText);

  // 5) 평당가
  const dealPricePerSpaceText = buildRangeText(
    filter.fromDpps,
    filter.toDpps,
    AptDealPricePerSpaceFromToOptions,
    "평당가",
  );
  if (dealPricePerSpaceText) parts.push(dealPricePerSpaceText);

  // 6) 전세가율
  const leasePriceRatioText = buildRangeText(
    filter.fromLpr,
    filter.toLpr,
    AptLeasePriceRatioFromToOptions,
    "전세가율",
  );
  if (leasePriceRatioText) parts.push(leasePriceRatioText);

  // 7) 매전갭
  const gapText = buildRangeText(
    filter.fromGap,
    filter.toGap,
    AptGapFromToOptions,
    "매전갭",
  );
  if (gapText) parts.push(gapText);

  return parts.join(", ");
};
